// extracted by mini-css-extract-plugin
module.exports = {"InsightItem":"InsightItem--3viF_","Icon":"Icon--14WlY","Hidden":"Hidden--2cfOI","Title":"Title--2Dtg_","Caret":"Caret--2Y7GS"};